<template>
    <div class="container">
        <Loading v-if="!loaded"></Loading>
        <div v-else>
            <!-- BUTTON: BACK -->
            <button class="btn btn-light mt-3" v-on:click="$router.back()">
                {{ $t('back') }}
            </button>
            <div class="alert alert-success" v-show="success" role="alert">{{ $t('saved') }} !</div>
            <div class="row mt-md-3">
                <!-- EDIT ROLE FORM -->
                <div class="col-sm-5">
                    <ValidationObserver v-slot="{ handleSubmit }">
                        <form role="form" @submit.prevent="handleSubmit(submit)">
                            <div class="form-group">
                                <!-- NAME -->
                                <ValidationProvider name="Name" rules="required" v-slot="{ errors }">
                                    <label for="name">{{ $t('name') }}</label>
                                    <input type="text" class="form-control" id="name" v-model="role.name" />
                                    <div class="invalid-feedback" style="display: block">
                                        <span>{{ $t(errors[0]) }}</span>
                                    </div>
                                </ValidationProvider>
                            </div>
                            <div class="form-group">
                                <!-- SLUG -->
                                <ValidationProvider name="Slug" rules="required" v-slot="{ errors }">
                                    <label for="slug">{{ $t('slug') }}</label>
                                    <input type="text" class="form-control" id="slug" v-model="role.slug" />
                                    <div class="invalid-feedback" style="display: block">
                                        <span>{{ $t(errors[0]) }}</span>
                                    </div>
                                </ValidationProvider>
                                <div class="alert alert-danger mt-3" v-show="submitted && error.slug" role="alert">
                                    <div v-for="(item, index) in error.slug" v-bind:key="index">
                                        {{ item }}
                                    </div>
                                </div>
                            </div>
                            <!-- DESCRIPTION -->
                            <div class="form-group">
                                <label for="description">{{ $t('description') }}</label>
                                <textarea class="form-control" id="description" v-model="role.description"></textarea>
                            </div>
                            <!-- BUTTON: SUBMIT -->
                            <input type="submit" class="btn btn-success mt-2" :value="$t('save')" />
                        </form>
                    </ValidationObserver>
                </div>
                <!-- PERMISSIONS TABLE -->
                <div class="col-sm-4 offset-1">
                    <div class="alert alert-danger mt-3" v-show="invalidPermissions" role="alert">
                        Pick at least one permission
                    </div>
                    <table class="table table-borderless table-hover">
                        <thead>
                            <tr>
                                <th>{{ $t('permissions') }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                v-for="permission of permissionsList"
                                v-bind:key="permission"
                                v-on:click="() => addPermission(permission)"
                            >
                                <td>
                                    <div class="row">
                                        <div class="col-sm-10">
                                            {{ $t(`permission_${permission}`) }}
                                        </div>
                                        <div class="col-sm-2">
                                            <img
                                                src="@/assets/images/done.svg"
                                                alt=""
                                                class="doctype-icon"
                                                v-if="role.permissions.includes(permission)"
                                            />
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Loading from '@/views/partial/Loading';
import { getRole, updateRole, handleAxiosError } from '@/services/axiosService';
import { permissions } from '@/services/roleService';

export default {
    components: { Loading },
    data() {
        return {
            success: false,
            submitted: false,
            loaded: true,
            role: {
                name: null,
                slug: null,
                description: null,
                permissions: []
            },
            permissionsList: permissions,
            error: {},
            invalidPermissions: false
        };
    },
    async created() {
        // get role based on route param
        await this.getRole();
        this.loaded = true;
    },
    methods: {
        // add permission to role
        addPermission(id) {
            if (!this.role.permissions.includes(id)) {
                this.role.permissions.push(id);
            } else {
                this.role.permissions = this.role.permissions.filter(permissionId => {
                    return permissionId !== id;
                });
            }
        },
        // format slug based on role name
        generateSlug() {
            this.role.slug = _.snakeCase(this.role.name);
        },
        // get role based on route parameter
        async getRole() {
            try {
                this.role = await getRole(this.$route.params.id);
                this.role.permissions = Object.keys(response.data.result.permissions);
            } catch (error) {
                handleAxiosError(error);
            }
        },
        // check if permission is empty
        isPermissionsEmpty() {
            return this.role.permissions.length === 0;
        },
        // submit form
        async submit() {
            if (this.isPermissionsEmpty()) {
                this.invalidPermissions = true;
            } else {
                try {
                    await updateRole(this.$route.params.id, this.role);
                    this.success = true;
                    setTimeout(() => {
                        this.success = false;
                    }, 2000);
                    this.submitted = false;
                } catch (error) {
                    handleAxiosError(error);
                }
            }
        }
    }
};
</script>
